import mitt, { Handler, type Emitter } from 'mitt'

export const enum EmitterEvents {
  /** 支付成功 */
  PAY_SUCCESS = 'PAY_SUCCESS',
  /** 登录成功 */
  LOGIN_SUCCESS = 'LOGIN_SUCCESS',
}

export const enum MobileEmitterEvents {
  /** 登录成功 */
  MOBILE_LOGIN_SUCCESS = 'MOBILE_LOGIN_SUCCESS',
}

type Events = {
  [EmitterEvents.PAY_SUCCESS]: void
  [EmitterEvents.LOGIN_SUCCESS]: void
  [MobileEmitterEvents.MOBILE_LOGIN_SUCCESS]: void
}

type MittWithOnce = Emitter<Events> & {
  once<Key extends keyof Events>(type: Key, handler: Handler<Events[Key]>): void
}

const emitter: MittWithOnce = mitt<Events>() as MittWithOnce

emitter.once = <Key extends keyof Events>(type: Key, handler: Handler<Events[Key]>) => {
  const wrapper: Handler<Events[Key]> = (...event) => {
    handler(...event)
    emitter.off(type, wrapper)
  }
  emitter.on(type, wrapper)
}

export default emitter
